module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "info-icon-gray.3fe5155e.svg";